<template>
	<div :class="'img-' + size" class="custom-icon">
		<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M40.878 19.145L58.783 4.934a10 10 0 0112.434 0l17.768 14.101h0m22.158 17.586l13.074 10.376A10 10 0 01128 54.83V118c0 5.523-4.477 10-10 10H12c-5.523 0-10-4.477-10-10V54.83a10 10 0 013.783-7.833l13.562-10.763h0" class="path" stroke="#0C2340"/><path d="M20 70.936h0V25a5 5 0 015-5h80a5 5 0 015 5v46.435h0M42.5 41.5h45m-45 14h45m-45 14h30" class="highlight" stroke="#00BBDC"/><path d="M2 105.233A10 10 0 015.783 97.4l53-42.063a10 10 0 0112.434 0l53 42.063a10 10 0 013.783 7.833" class="path" stroke="#0C2340" transform="matrix(1 0 0 -1 0 158.403)"/></g></svg>
	</div>
</template>

<script>
export default {
	props: {
		size: {
			type: String,
			default: '4x'
		}
	}
}
</script>